
import { Component, Vue } from 'vue-property-decorator';
import { getCustomerStatistics, exportCustomerStatistics } from '@/api/statisticsCustomer';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'StatisticsCustomerNew',
  components: {
  }
})
export default class extends Vue {
  private formSearch: any = {
    timePeriods: ''
  }

  private pickerOptions: any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const end = new Date(today);
        const start = new Date(today);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const end = new Date(today);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const end = new Date(today);
        const start = new Date(today);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const end = new Date(today);
        const start = new Date(today);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private loading = false
  private tableData: any = []
  private titleData: any = {}

  private handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.getList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private handleExport() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      type: 5
    };

    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      params.diy_start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      params.diy_end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }

    exportCustomerStatistics(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {
      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  created() {
    this.initTimePeriods();
    this.getList();
  }

  private initTimePeriods() {
    const dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    const dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59';
    this.formSearch.timePeriods = [new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime()];
  }

  private getList() {
    const orderParams: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      type: 5,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };

    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.diy_start_time = this.formSearch.timePeriods[0] / 1000;
      orderParams.diy_end_time = this.formSearch.timePeriods[1] / 1000;
    }

    this.loading = true;
    getCustomerStatistics(orderParams).then(res => {
      if (res && res.data && res.data.list) {
        this.titleData = res.data.titleDesc || {};
        this.tableData = res.data.list;
        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);
      } else {
        this.titleData = res.data && res.data.titleDesc ? res.data.titleDesc : {};
        this.tableData = [];
        this.pagination.total = 0;
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
    });
  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  private handleClear() {
    this.formSearch = {
      timePeriods: []
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
